import { Component } from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {
    brand,
    brandLogoSvg,
} from '../../../../../settings';

@Component({
  selector: 'app-login-logo',
  standalone: true,
  imports: [
    MatIconModule
  ],
  templateUrl: './login-logo.component.html',
  styleUrl: './login-logo.component.scss'
})
export class LoginLogoComponent {
    public readonly brand = brand;
    public readonly brandLogoSvg = brandLogoSvg;

}
